import React, {FC, createContext, useContext} from 'react'
import {WithChildren} from '../helpers'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'
const IRAN_API_URL = 'https://iran.bitsobit.academy/core/public/api'

type Props = {
  selectedLang: 'en' | 'fa' | 'ar' | 'de' | 'es' | 'fr' | 'ja' | 'tr' | 'zh' | 'ru'
}

function getDefaultLang(): Props['selectedLang'] {
  const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '')
  return apiUrl === IRAN_API_URL ? 'fa' : 'en'
}

const initialState: Props = {
  selectedLang: getDefaultLang(),
}

const ALLOWED_LANGS: Props['selectedLang'][] = ['en', 'fa', 'ar', 'de', 'es', 'fr', 'ja', 'tr', 'zh', 'ru']

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      const parsed = JSON.parse(ls) as Props
      if (ALLOWED_LANGS.includes(parsed.selectedLang)) {
        return parsed
      }
    } catch (er) {
      console.error(er)
    }
  }
  return {selectedLang: getDefaultLang()}
}

// Side effect
export function setLanguage(lang: string) {
  if (!ALLOWED_LANGS.includes(lang as Props['selectedLang'])) {
    return
  }
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang as Props['selectedLang']}))
  window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  const lang = getConfig()
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang}
